import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createEvent as createAnalyticEvent, fetchAnalytics } from "./api";

const initialState = {
  totalEvents: undefined,
  events: undefined,
  status: "idle",
};

export const getAnalytics = createAsyncThunk(
  "analytics/fetchAnalytics",
  async (query) => {
    const response = await fetchAnalytics(query);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const createEvent = createAsyncThunk(
  "analytics/createEvent",
  async (payload) => {
    const response = await createAnalyticEvent(payload);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // increment: (state) => {state.value += 1;},
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(getAnalytics.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAnalytics.fulfilled, (state, action) => {
        state.status = "idle";
        state.events = action.payload.events;
        state.totalEvents = action.payload.totalEvents;
      })
      .addCase(getAnalytics.rejected, (state, action) => {
        console.log("ERROR", action);
      });
  },
});

// export const { increment, decrement, incrementByAmount } = analyticsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.analytics.value)`
export const selectEvents = (state) => state.analytics.events;
export const selectTotalEvents = (state) => state.analytics.totalEvents;

export default analyticsSlice.reducer;
